// import React from "react";
// import { Route, Redirect } from "react-router-dom";
// import { useSelector } from "react-redux";

// const PrivateRoute = ({ component: Component, ...rest }) => {
//   const isAuthenticated = useSelector(
//     (state) => state.LoginSlicer.isAuthenticated
//   );

//   return (
//     <Route
//       {...rest}
//       render={(props) =>
//         isAuthenticated ? <Component {...props} /> : <Redirect to="/login" />
//       }
//     />
//   );
// };

// export default PrivateRoute;



import React, { useEffect } from "react";
import { Route, Redirect } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { checkUserSessionAction } from "../signIn/signIn.action";

const PrivateRoute = ({ component: Component, ...rest }) => {
  const dispatch = useDispatch();
  
  const isAuthenticated = useSelector(
    (state) => state?.loginSlicer?.isAuthenticated || false
  );

  useEffect(() => {
    const token = localStorage.getItem("AdminHeaven");
    if (token && !isAuthenticated) {
      dispatch(checkUserSessionAction());
    }
  }, [dispatch, isAuthenticated]);

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? (
          <Component {...props} />
        ) : (
          <Redirect to="/login" />
        )
      }
    />
  );
};

export default PrivateRoute;



// import React, { useEffect } from "react";
// import { Route, Redirect } from "react-router-dom";
// import { useSelector, useDispatch } from "react-redux";
// import { checkUserSessionAction } from "../signIn/signIn.action";

// const PrivateRoute = ({ component: Component, ...rest }) => {
//   const dispatch = useDispatch();
  
//   const { 
//     isAuthenticated = false, 
//     isSessionLoading = true 
//   } = useSelector((state) => state.loginSlicer || {});

//   useEffect(() => {
//     const token = localStorage.getItem("AdminHeaven");
//     if (token) {
//       dispatch(checkUserSessionAction());
//     }
//   }, [dispatch]);

//   return (
//     <Route
//       {...rest}
//       render={(props) => {
//         if (isSessionLoading) {
//           return <div>Verifying session...</div>;
//         }

//         return isAuthenticated ? (
//           <Component {...props} />
//         ) : (
//           <Redirect to="/login" />
//         );
//       }}
//     />
//   );
// };

// export default PrivateRoute;